import _ from 'lodash';
import {
  ProfessionalsDownloadsProductsStore,
  ProfessionalsDownloadsProductsActions,
  ProfessionalsDownloadsProductFiltersType,
  ProfessionalsDownloadsProductPaginationType,
  ProfessionalsDownloadsProductSortOrderType,
} from './types';
import { ProductEntity } from 'src/modules/products';

const filterProducts = (filters: ProfessionalsDownloadsProductFiltersType, products: any[]) => {
  let filteredProducts = [];

  const isSubcategories = (product: ProductEntity) => {
    // No categories selected
    if (_.isEmpty(filters.productCategories)) return true;

    // One ore more subcategories selected
    return _.some(filters.productCategories, (filter) =>
      _.some(product.product_categories, ({ id }) => {
        return id === filter.id;
      })
    );
  };

  const isLocationTypes = (product: ProductEntity) => {
    // No location types selected
    if (_.isEmpty(filters.locationTypes)) return true;

    // One ore more location types selected
    return _.some(filters.locationTypes, (filter) =>
      _.some(product.location_types, (locationType) => locationType.id === filter.id)
    );
  };

  filteredProducts = _.filter(
    products,
    (product) => isSubcategories(product) && isLocationTypes(product)
  );

  return filteredProducts;
};

const filterResults = (
  results: ProductEntity[],
  filters: ProfessionalsDownloadsProductFiltersType
) => {
  if (!filters) return results;

  const filterByTerm = (_results: ProductEntity[]) => {
    if (!filters?.term) return _results;

    const term = filters.term.toLowerCase();

    return _.filter(
      _results,
      (r) => r.name_en.toLowerCase().includes(term) || r.name_de.toLowerCase().includes(term)
    );
  };

  return filterProducts(filters, filterByTerm(results));
};

import { Locale } from 'src/modules/locale/types';
export const defaultState: ProfessionalsDownloadsProductsStore = {
  error: null,
  isDataLoading: false,
  isDataLoaded: false,
  isDetailsLoading: false,
  isDetailsLoaded: false,
  isResultsLoading: false,
  isResultsLoaded: false,
  result: null,
  results: [],
  allResults: [],
  isSearchSuggestionsResultsLoading: false,
  searchSuggestionsResults: null,
  productCategories: [],
  locationTypes: [],
  filters: {
    productCategories: [],
    locationTypes: [],
    locale: Locale.EN,
    term: '',
  },
  pagination: {
    offset: 0,
    limit: 100,
  },
  sortOrder: {
    name: 'name',
    direction: 'asc',
  },
  searchResultsCount: -1,
};

const reducer = (
  state: ProfessionalsDownloadsProductsStore = defaultState,
  action: {
    type: ProfessionalsDownloadsProductsActions;
    payload?: any;
    searchResultsCount?: number;
    filters?: ProfessionalsDownloadsProductFiltersType;
    pagination?: ProfessionalsDownloadsProductPaginationType;
    sortOrder?: ProfessionalsDownloadsProductSortOrderType;
  }
): ProfessionalsDownloadsProductsStore => {
  switch (action.type) {
    case ProfessionalsDownloadsProductsActions.FetchDataBegin: {
      return {
        ...state,
        isDataLoading: true,
        isDataLoaded: false,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.FetchDataError: {
      return {
        ...state,
        isDataLoading: false,
        isDataLoaded: true,
        error: action.payload,
      };
    }
    case ProfessionalsDownloadsProductsActions.FetchDataSuccess: {
      return {
        ...state,
        productCategories: action.payload.productCategories,
        locationTypes: action.payload.locationTypes,
        isDataLoading: false,
        isDataLoaded: true,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.FetchDetailsBegin: {
      return {
        ...state,
        isDetailsLoading: true,
        isDetailsLoaded: false,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.FetchDetailsError: {
      return {
        ...state,
        isDetailsLoading: false,
        isDetailsLoaded: true,
        error: action.payload,
      };
    }
    case ProfessionalsDownloadsProductsActions.FetchDetailsSuccess: {
      return {
        ...state,
        result: action.payload,
        isDataLoading: false,
        isDataLoaded: true,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchBegin: {
      return {
        ...state,
        isResultsLoading: true,
        isResultsLoaded: false,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchError: {
      return {
        ...state,
        isResultsLoading: false,
        isResultsLoaded: false,
        error: action.payload,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchSuccess: {
      const allResults = action.payload || state.allResults;
      const results = filterResults(allResults, action.filters);
      return {
        ...state,
        allResults,
        results,
        filters: action.filters || state.filters,
        searchResultsCount: results.length,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchSuggestionsBegin: {
      return {
        ...state,
        isSearchSuggestionsResultsLoading: true,
        error: null,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchSuggestionsError: {
      return {
        ...state,
        isSearchSuggestionsResultsLoading: false,
        error: action.payload,
      };
    }
    case ProfessionalsDownloadsProductsActions.SearchSuggestionsSuccess: {
      return {
        ...state,
        searchSuggestionsResults: filterResults(state.allResults, action.filters),
        filters: action.filters || state.filters,
        searchResultsCount: action.searchResultsCount || 0,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
